var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgMobileCallIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "call",
    transform: "translate(-1167 -271)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 24,
    height: 24,
    rx: 3,
    transform: "translate(1167 271)",
    fill: "#f4f4f6",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "smartphone_FILL0_wght300_GRAD-25_opsz20",
    d: "M219.655-867.922a1.149,1.149,0,0,1-.844-.348,1.149,1.149,0,0,1-.348-.844V-882.73a1.149,1.149,0,0,1,.348-.844,1.149,1.149,0,0,1,.844-.348h7.976a1.149,1.149,0,0,1,.844.348,1.149,1.149,0,0,1,.348.844v13.616a1.149,1.149,0,0,1-.348.844,1.149,1.149,0,0,1-.844.348Zm-.242-2.131v.937a.233.233,0,0,0,.076.168.233.233,0,0,0,.168.076h7.973a.233.233,0,0,0,.168-.076.233.233,0,0,0,.076-.168v-.937Zm0-.95h8.46v-9.839h-8.46Zm0-10.789h8.46v-.937a.233.233,0,0,0-.076-.168.233.233,0,0,0-.168-.076h-7.973a.233.233,0,0,0-.168.076.233.233,0,0,0-.076.168Zm0,0v0Zm0,11.739v0Z",
    transform: "translate(955.357 1158.922)",
    fill: "#3b3b3b"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMobileCallIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mobileCallIcon.8298d9b2.svg";
export { ForwardRef as ReactComponent };